import { z } from "zod"

export const MessageMediaUploadId = z.coerce
  .string()
  .regex(/[0-9]{1,16}/)
  .brand<"MessageMediaUploadId">()
export type MessageMediaUploadId = z.infer<typeof MessageMediaUploadId>

export const MessageMediaUploadApiPayload = z.object({
  media_message_upload: z.object({
    id: MessageMediaUploadId,
    mime_type: z.string(),
    media_url: z.string().url(),
    thumbnail_url: z.string().url(),
  }),
})

export type MessageMediaUploadApiPayload = z.infer<
  typeof MessageMediaUploadApiPayload
>

export default class MessageMediaUploadModel {
  private readonly mediaMessageUpload: MessageMediaUploadApiPayload["media_message_upload"]

  constructor(payload: MessageMediaUploadApiPayload) {
    this.mediaMessageUpload = payload.media_message_upload
  }

  get id(): MessageMediaUploadId {
    return this.mediaMessageUpload.id
  }

  get mimeType() {
    return this.mediaMessageUpload.mime_type
  }

  get mediaUrl() {
    return this.mediaMessageUpload.media_url
  }

  get thumbnailUrl() {
    return this.mediaMessageUpload.thumbnail_url
  }
}
